<template>
<!-- 反馈及意见 -->
  <div class="content">
    <span class="con_title">反馈及意见</span>
    <!-- form -->
    <div class="form">
      <el-form :model="opinionForm" :rules="rules" ref="opinionForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="标题：" prop="title">
          <el-input size="small" v-model="opinionForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="建议内容：" prop="description">
          <el-input type="textarea" :autosize="{minRows: 6}" resize="none" v-model="opinionForm.description" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="上传附件：">
          <el-upload
            ref="upload"
            class="upload-demo"
            action="string" 
            :http-request="uploadImg"
            :limit="1">
            <el-button class="upload_btn" size="small" plain icon="el-icon-upload">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <div class="tips">个数及大小限制：1个附件，大小不超过10M</div>
              <div class="tips">支持格式：zip、rar、doc、docx、xls、pdf、txt、jpg、jpeg、png</div>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit_btn" @click="submit">提交</div>
  </div>
</template>

<script>
import { addFeedback } from '@/api/console/supportServices.js'
import { obsUploadFile } from '@/api/resource.js'
import token from '@/utils/token.js'
export default {
  data() {
    return {
      opinionForm: {
        title: '',
        description: '',
        fileUrl: '',
        userId: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    //上传附件
    uploadImg(param) {
			let formData = new FormData();
      formData.append("file", param.file);
      obsUploadFile(formData).then(res=> {
        this.opinionForm.fileUrl = res.data;
      })
    },
    //提交表单
    submit() {
      this.$refs['opinionForm'].validate((valid) => {
        if(valid) {
          let param = {
            ...this.opinionForm,
            userId: token.getUser().id
          };
          addFeedback(param).then(()=> {
            this.$message.success('提交成功!');
            this.$refs['opinionForm'].resetFields();
            this.$refs.upload.clearFiles();
          })
        } else {
          return false;
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped="scoped">
.content {
  position: relative;
  width: 60%;
  padding: 20px 20px 60px;
  margin: 20px 20%;
  border: 1px solid #E5E5E5;
  .con_title {
    color: #4F4F4F;
  }
  .form {
    width: 75%;
    margin-top: 30px;
    .tips {
      font-size: 12px;
      color: #AAA;
      line-height: 20px;
    }
  }
  .submit_btn {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 132px;
    height: 32px;
    background-color: #5984EC;
    color: #fff;
    text-align: center;
    line-height: 32px;
  }
  .submit_btn:hover {
    cursor: pointer;
  }
}
</style>